import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoBusPlaceholder, LazySvgoFleequidLogo, LazySvgoPaymentApplePay, LazySvgoPaymentCardAmex, LazySvgoPaymentCardDiners, LazySvgoPaymentCardDiscover, LazySvgoPaymentCardJbc, LazySvgoPaymentCardMastercard, LazySvgoPaymentCardUnionpay, LazySvgoPaymentCardVisa, LazySvgoPaymentCreditCardEmpty, LazySvgoPaymentGooglePay, LazySvgoPaymentPayPalFull, LazySvgoPaymentPayPalLogo, LazySvgoPoweredByStripe, LazySvgoSteeringWheel, LazySvgoWhatsappGreen, LazySvgoWhatsapp, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoBusPlaceholder", LazySvgoBusPlaceholder],
["SvgoFleequidLogo", LazySvgoFleequidLogo],
["SvgoPaymentApplePay", LazySvgoPaymentApplePay],
["SvgoPaymentCardAmex", LazySvgoPaymentCardAmex],
["SvgoPaymentCardDiners", LazySvgoPaymentCardDiners],
["SvgoPaymentCardDiscover", LazySvgoPaymentCardDiscover],
["SvgoPaymentCardJbc", LazySvgoPaymentCardJbc],
["SvgoPaymentCardMastercard", LazySvgoPaymentCardMastercard],
["SvgoPaymentCardUnionpay", LazySvgoPaymentCardUnionpay],
["SvgoPaymentCardVisa", LazySvgoPaymentCardVisa],
["SvgoPaymentCreditCardEmpty", LazySvgoPaymentCreditCardEmpty],
["SvgoPaymentGooglePay", LazySvgoPaymentGooglePay],
["SvgoPaymentPayPalFull", LazySvgoPaymentPayPalFull],
["SvgoPaymentPayPalLogo", LazySvgoPaymentPayPalLogo],
["SvgoPoweredByStripe", LazySvgoPoweredByStripe],
["SvgoSteeringWheel", LazySvgoSteeringWheel],
["SvgoWhatsappGreen", LazySvgoWhatsappGreen],
["SvgoWhatsapp", LazySvgoWhatsapp],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
